import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
// import CardMedia from '@material-ui/core/CardMedia';
// import CardContent from '@material-ui/core/CardContent';
// import CardActions from '@material-ui/core/CardActions';
// import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
// import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import ShareIcon from '@material-ui/icons/Share';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import HomeIcon from '@material-ui/icons/Home';
import BusinessIcon from '@material-ui/icons/Business';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import normalizeMobilePhone from '../../../../../../../fns/normalizeMobile';
import EditPhone from "./EditPhone"
import CallUser from "../../../../../../../components/User/CallUser"

const useStyles = makeStyles((theme) => ({
    root: {
      maxWidth: 345,
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    avatar: {
      backgroundColor: red[500],
    },
  }));

const Phone = ({phone,deletePhone,editPhone}) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const icons = {
        'work':<BusinessIcon />,
        'home':<HomeIcon />,
        'mobile':<PhoneIphoneIcon />
    }
  
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [editDialog,setEditDialog] = useState(false);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleDelete = () => {
      deletePhone(phone._id);
      handleClose()
    }
    const handleOpenEditDialog = ()=>{
      setEditDialog(true);
    }
    const handleCloseEditDialog = (agree)=>{
      setEditDialog(false);
      handleClose();
    }

   
  
    return (
      <>
        <Card className={classes.root}>
          <CardHeader
            avatar={
              <Avatar className={classes.avatar}>
                {icons[phone.phoneIcon]}
              </Avatar>
            }
            action={
              <IconButton onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
            }
            title={<CallUser tel={phone.phoneNumber} title={`${phone?.phoneTitle?`${phone.phoneTitle} - `:''}${normalizeMobilePhone(phone.phoneNumber)} ${phone?.phoneExt?' داخلی: '+phone.phoneExt:''}`} />}
            subheader={`${phone?.phoneDescription || ''}`}
          />
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={handleOpenEditDialog}>ویرایش</MenuItem>
            <MenuItem onClick={handleDelete}>حذف</MenuItem>
          </Menu>
          
        </Card>
        {editDialog && <EditPhone phone={phone} onClose={handleCloseEditDialog} />}
      </>
    );
}

export default React.memo(Phone)